// API configuration
// Use environment variable or default based on platform
const normalizeBaseUrl = (url) => {
  if (!url) return url;
  return url.replace(/\/+$/, "");
};

const getDefaultApiBase = () => {
  // Check if running on Capacitor native platform (mobile app)
  // We need to check this way because importing Capacitor sets window.Capacitor even in browser
  let isNativePlatform = false;
  try {
    // Only check if Capacitor is available and we're actually on a native platform
    if (typeof window !== 'undefined' && window.Capacitor) {
      // Use Capacitor.isNativePlatform() to properly detect native platform
      // This returns true only on actual mobile devices, not in browser
      isNativePlatform = window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform();
    }
  } catch (e) {
    // If Capacitor check fails, assume we're in browser
    isNativePlatform = false;
  }

  const envMobileBase = process.env.REACT_APP_API_BASE_URL_MOBILE;
  const envWebBase = process.env.REACT_APP_API_BASE_URL;

  if (isNativePlatform) {
    // Mobile builds must use their own env var to avoid inheriting a web-dev localhost URL.
    if (!envMobileBase) {
      throw new Error(
        "Missing API base URL for native runtime. Set REACT_APP_API_BASE_URL_MOBILE."
      );
    }
    return normalizeBaseUrl(envMobileBase);
  }

  // Web/development - use environment variable or default to localhost
  if (process.env.NODE_ENV === "production" && !envWebBase) {
    throw new Error("Missing REACT_APP_API_BASE_URL for production web build.");
  }
  return normalizeBaseUrl(envWebBase || "http://localhost:8000");
};

export const API_BASE = getDefaultApiBase();

export const FRONTEND_URL = (
  process.env.REACT_APP_FRONTEND_URL || window.location.origin
).replace(/\/+$/, "");

const apiConfig = {
  API_BASE,
  FRONTEND_URL,
};

export default apiConfig;
